<template>
  <div
    class="relative aspect-square w-full"
    :class="[perspectives.length === 1 && 'text-on-primary-container']"
  >
    <div
      v-if="isAMatch"
      class="absolute top-0 left-0 z-0 -m-1 h-[calc(100%+8px)] w-[calc(100%+8px)]"
      :class="[!disableAnimation && 'animate-rotate']"
    >
      <BaseShape
        shape="sunny"
        class="text-on text-primary-container stroke-primary stroke-2"
        :class="[!disableAnimation && 'animate-bouncy-spin']"
      />
    </div>
    <BaseShape
      v-else-if="perspectives.length === 1"
      :shape="shapeForPerspective(perspectives[0]!)"
      class="absolute top-0 left-0 z-0 stroke-3"
      :class="[colorClassesForPerspective(perspectives[0]!, topicPerspectives ?? [], 'svg')]"
    />
    <BaseShape
      v-else-if="perspectives.length > 1"
      shape="circle"
      class="text-primary-container stroke-primary absolute top-0 left-0 z-0 stroke-2"
    />
    <PerspectiveDotIcon :perspectives="perspectives" :allPerspectives="topicPerspectives ?? []" />
  </div>
</template>
<script lang="ts" setup>
  import {
    colorClassesForPerspective,
    shapeForPerspective,
  } from '@/core/models/feedback-perspective'
  import { SELF_PERSPECTIVE_KEY } from '@/core/models/perspective'
  import { computed } from 'vue'
  import BaseShape from '../../base/shapes/BaseShape.vue'
  import PerspectiveDotIcon from './PerspectiveDotIcon.vue'
  import type { Perspective } from '@/core/models/perspective.ts'

  const props = defineProps<{
    perspectives: Perspective[]
    topicPerspectives?: ReadonlyArray<Perspective>
    disableAnimation?: boolean
  }>()

  const isSelfIncluded = computed(() => {
    return props.perspectives.some((p) => p.key === SELF_PERSPECTIVE_KEY)
  })

  const isAMatch = computed(() => {
    return props.perspectives.length >= 2 && isSelfIncluded.value
  })
</script>
